import {Axis} from './axis.model';
import {Utilities} from '../../shared/utilities/utilities.model';

export class Tyres {
	axis1: Axis;
	axis2: Axis;
	flag_delivery_tyres = false;
	saving = false;

	static getCleanBody(): any {
		const voidAxis = new Axis({dot_week: '', dot_year: '', txt_load_rating: '', txt_make: '', txt_ratio: '', txt_season: '', txt_speed_rating: '', txt_tipologia: '', txt_tread_width: '', txt_wheel_diameter: ''})
		return {
			'1': voidAxis,
			'2': voidAxis
		};
	}

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			if (!Utilities.isVoid(model.flag_delivery_tyres)) {
				if (typeof model.flag_delivery_tyres === 'string') {
					if (model.flag_delivery_tyres.toString().toLowerCase() === 'true') {
						this.flag_delivery_tyres = true;
					}
				} else {
					this.flag_delivery_tyres = model.flag_delivery_tyres;
				}
			}
			if (model['1']) {
				this.axis1 = new Axis(model['1']);
			} else if (model.axis1) {
				this.axis1 = new Axis(model.axis1);
			}
			if (model['2']) {
				this.axis2 = new Axis(model['2']);
			} else if (model.axis2) {
				this.axis2 = new Axis(model.axis2);
			}
		}
	}


	getBody(): any {
		return {
			'1': this.axis1,
			'2': this.axis2
		};
	}

	isReady(): boolean {
		return this.axis1.isReady() && this.axis2.isReady();
	}

	update(model: Tyres) {
		if (model) {
			this.axis1.update(model.axis1);
			this.axis2.update(model.axis2);
		}
	}

	isChanged(model: any) {
		return Utilities.isVoid(model) || this.axis1.isChanged(model.axis1) || this.axis2.isChanged(model.axis2);
	}
}
